// Squarify treemap layout algorithm
export const buildRectangles = (
  industries,
  containerWidth,
  containerHeight
) => {
  const sorted = [...industries].sort((a, b) => b.value - a.value);
  const rects = [];
  const spacing = 4;

  const squarify = (arr, x, y, w, h) => {
    if (!arr.length) return;
    if (arr.length === 1) {
      rects.push({ ...arr[0], x, y, width: w, height: h });
      return;
    }
    const total = arr.reduce((s, d) => s + d.value, 0);
    const ratio = arr[0].value / total;
    if (w > h) {
      const itemWidth = w * ratio;
      rects.push({
        ...arr[0],
        x,
        y,
        width: itemWidth - spacing,
        height: h - spacing,
      });
      squarify(arr.slice(1), x + itemWidth, y, w - itemWidth, h);
    } else {
      const itemHeight = h * ratio;
      rects.push({
        ...arr[0],
        x,
        y,
        width: w - spacing,
        height: itemHeight - spacing,
      });
      squarify(arr.slice(1), x, y + itemHeight, w, h - itemHeight);
    }
  };

  squarify(sorted, 0, 0, containerWidth, containerHeight);
  return rects;
};

export const getTreemapFontSize = (rectWidth, isMobile) => {
  if (isMobile) return rectWidth > 60 ? "10px" : rectWidth > 40 ? "9px" : "8px";
  return rectWidth > 80 ? "11px" : rectWidth > 50 ? "10px" : "9px";
};
